import styled from "styled-components/native";

export const TextWrapper = styled.Text`
  font-family: "HKNovaMedium";
`;

export const Text = (props: any) => {
  return <TextWrapper>{props.children}</TextWrapper>;
};
